import styled from 'styled-components';

export default styled.div`
  border-bottom: 1px solid ${props => (props.color ? props.color : '#d9d9d9')};
`;



// WEBPACK FOOTER //
// ./src/components_new/common/Line.js